var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('MainChartTable',{attrs:{"set_data":_vm.set_data,"selectedData":_vm.revenue}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }